export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#2F91E7',
    light: '#D1E4F9',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#00396E',
    light: 'rgba(255, 255, 255, 0.2)',
    contrastText: '#22211F',
  },
  text: {
    brand: '#00396E',
    primary: '#0F0F0F',
    primaryInverse: '#001327',
    secondary: '#49515B',
    tertiaryLight: '#626D7C',
    tertiary: '#3E444E',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    contrastText: '#22211F',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#003964',
    fill: '#FFFFFC',
    hero1: '#F1F7FE',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#163A98',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#00396E',
    tableSubhead: '#F7F8F8',
    tableBorder: '#D7DBE0',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDEEF1',
    secondaryLight: '#D1E4F9',
    primaryLight: '#D9EDF7',
    ribbon: '#BBE6FE',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: 'linear-gradient(180deg, #0B1A70 0%, #153795 100%)',
    learnMore: '#F4F4F4',
    header: '#FAFAFA',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#00396E',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
